import React from 'react'
import Container from '../Reusable'

import styles from './index.module.css'

const Parent = () => (
  <div className={styles.container}>
    <Container customCSS={styles.customStyles} />
  </div>
)

export default Parent